import React, { lazy } from 'react';
import './App.scss'
import { Routes, Route } from 'react-router-dom';
import Topbar from './Components/Topbar';
import BackgroundImage from './Assets/preemBackground.jpg'
import NotFound from './Components/NotFound';

const Home = lazy(() => import('./Components/Home'));
const Products = lazy(() => import('./Components/Products'));

function App() {
  return (
    <div className='PreemBakes'>
      <img src={BackgroundImage} alt='BackgroundImage' className='BackgroundImage' draggable={false}/>
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/home" element={<Home />}/>
        <Route path="/home/:page" element={<Home />}/>
        <Route path="/home/:page/:item" element={<Home />}/>
        {/* <Route path="/order" element={<Products />}/>
        <Route path="/order/:item" element={<Products />}/> */}
        <Route path="*" element={<NotFound />}/>
      </Routes>
      <Topbar/>
      <div className='TextOverlay'>PREEM BAKES</div>
    </div>
  );
}

export default App;
